import { render, staticRenderFns } from "./MotivosDeAnulacion.vue?vue&type=template&id=cc72cfbc"
import script from "./MotivosDeAnulacion.vue?vue&type=script&lang=js"
export * from "./MotivosDeAnulacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports